export const tooltipStyle = {
  position: 'fixed',
  visibility: 'visible',
  display: 'block',
  opacity: 1,
  width: '250px',
  backgroundColor: 'white',
  border: '1px solid #ddd',
  borderRadius: '4px',
  padding: '12px',
  boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
  zIndex: 1200,
  maxWidth: '300px',
  maxHeight: '80vh',
  overflowY: 'auto',
  fontSize: '14px',
  pointerEvents: 'none',
  transition: 'opacity 0.2s ease-in-out',
  transform: 'translate(10px, 10px)'
};

export const titleStyle = {
  marginBottom: '8px', 
  color: '#2B4B81',
  textAlign: 'left'
};

export const dividerStyle = {
  height: '1px', 
  background: '#ddd', 
  margin: '12px 0', 
  padding: '0 8px'
};

export const contentStyle = {
  display: 'flex', 
  flexDirection: 'column', 
  gap: '8px',
  textAlign: 'left',
  marginTop: '8px'
};

export const statusStyle = {
  fontWeight: '500'
};

export const subcategoriesContainerStyle = {
  display: 'flex', 
  flexDirection: 'column', 
  gap: '4px'
};

export const subcategoriesHeaderStyle = {
  color: '#666',
  fontSize: '14px',
  marginBottom: '4px'
};

export const subcategoriesCountStyle = {
  color: '#2B4B81', 
  fontSize: '18px',
  fontWeight: '500'
};

export const subcategoryItemStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  fontSize: '13px',
  color: '#2B4B81'
};

export const bulletPointStyle = {
  color: '#666'
};

export const relatedLocationsStyle = {
  marginTop: '8px',
  padding: '8px',
  backgroundColor: '#f5f7fa',
  borderRadius: '4px'
};

export const relatedLocationsHeaderStyle = {
  color: '#666',
  fontSize: '12px',
  marginBottom: '4px'
};

export const relatedLocationItemStyle = {
  fontSize: '12px',
  padding: '2px 0'
};

export const fixedPanelStyle = {
  position: 'sticky',
  top: 0,
  width: '100%',
  backgroundColor: 'white',
  border: '1px solid #ddd',
  borderRadius: '4px',
  padding: '12px',
  boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
  maxHeight: 'calc(100vh - 24px)',
  overflowY: 'auto',
  fontSize: '14px',
};

export const moreItemsStyle = {
  fontSize: '13px',
  color: '#666',
  fontStyle: 'italic',
  padding: '4px 0',
  borderTop: '1px dashed #ddd',
  marginTop: '4px'
};

export const emptyStateStyle = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '24px 16px',
  color: '#666',
  fontSize: '14px',
  textAlign: 'center',
  height: '100%',
  minHeight: '200px',
  backgroundColor: '#f9f9f9',
  border: '1px dashed #ddd',
  borderRadius: '4px',
};

export const emptyStateIconStyle = {
  fontSize: '24px',
  marginBottom: '12px',
  color: '#999',
};

export const projectsContainerStyle = {
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
  padding: '8px',
  backgroundColor: '#f5f7fa',
  borderRadius: '4px',
  marginBottom: '8px'
};

export const projectsHeaderStyle = {
  color: '#666',
  fontSize: '14px',
  marginBottom: '4px'
};

export const projectsCountStyle = {
  color: '#2B4B81',
  fontSize: '16px',
  fontWeight: '500'
};

export const projectItemStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  fontSize: '13px',
  color: '#2B4B81'
};

export const emptyProjectsStyle = {
  color: '#666',
  fontSize: '13px',
  fontStyle: 'italic',
  padding: '4px 0'
}; 